import { NavLink } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';
import { NAV_ITEMS } from './navigation';

export const BottomNav = () => (
  <nav
    className="sticky bottom-0 z-30 flex h-[72px] items-end justify-around bg-background/85 px-2 pb-[env(safe-area-inset-bottom)] pt-1.5 backdrop-blur-md shadow-[0_-1px_0_rgba(16,24,40,0.06),0_-12px_24px_-16px_rgba(16,24,40,0.16)] lg:hidden"
    aria-label="Navegação principal"
  >
    {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          cn(
            'group relative flex flex-1 flex-col items-center justify-end gap-1 pb-2 text-[11px] font-medium transition-colors',
            isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
          )
        }
      >
        {({ isActive }) => (
          <>
            <span
              className={cn(
                'flex h-8 w-14 items-center justify-center rounded-full transition-all duration-200',
                isActive ? 'bg-foreground/[0.08]' : 'group-hover:bg-muted',
              )}
            >
              <Icon
                className={cn(
                  'h-5 w-5 transition-transform duration-200',
                  isActive ? 'scale-110' : 'scale-100',
                )}
                aria-hidden
              />
            </span>
            <span className={isActive ? 'font-semibold' : 'font-medium'}>{label}</span>
          </>
        )}
      </NavLink>
    ))}
  </nav>
);
